export { Footer } from "./Footer";
export { default as AdminBackground } from "./AdminBackground";
export { Header } from "./Header";
// RichTextEditor is deliberately NOT re-exported here: it drags
// @uiw/react-md-editor (CodeMirror JS + wmde-markdown CSS) into the bundle —
// and, with inlineCss, into the HTML — of every page that touches this barrel.
// Admin pages import it directly from "@/components/common/RichTextEditor".
export { LanguageDropdown } from "./LanguageDropdown";
export { default as CacheInitializer } from "./CacheInitializer";
export { Button, PrimaryButton, SecondaryButton } from "./Button";
export { Text } from "./Text";
export {
  default as SkeletonLoader,
  SkeletonInput,
  SkeletonTextarea,
  SkeletonRichTextEditor,
  SkeletonSection,
  SkeletonFAQ,
  SkeletonTags,
  SkeletonImage,
  SkeletonRadioGroup,
  SkeletonSelect,
  HeaderSkeleton,
  EditPageSkeleton,
} from "./SkeletonLoader";
